import { render, staticRenderFns } from "./ApproveReportProjectDialog.vue?vue&type=template&id=5a6fa3d8&scoped=true"
import script from "./ApproveReportProjectDialog.vue?vue&type=script&lang=js"
export * from "./ApproveReportProjectDialog.vue?vue&type=script&lang=js"
import style0 from "./ApproveReportProjectDialog.vue?vue&type=style&index=0&id=5a6fa3d8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a6fa3d8",
  null
  
)

export default component.exports